export default "__VITE_ASSET__BkZaVdzx__"